/* import __COLOCATED_TEMPLATE__ from './buyer-new-dialog.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { EMBER_ROUTE_NAMES } from 'sh-www/constants/routes';

class BuyerNewDialog extends Component {
  @service router;
  
  @action
  onPostingOptionClicked() {
    this.args.closeAction();

    this.router.transitionTo(EMBER_ROUTE_NAMES.POSTING__CREATE);
  }

  @action
  onProjectOptionClicked() {
    this.args.closeAction();
    
    this.router.transitionTo(EMBER_ROUTE_NAMES.PROJECT__CREATE__FIND_FREELANCER);
  }
}

export default BuyerNewDialog;
